// @internal
export function isArray(value) {
  return Array.isArray(value);
}
